import { render, staticRenderFns } from "./BusinessDetailsV2.vue?vue&type=template&id=8836e554&scoped=true&"
import script from "./BusinessDetailsV2.vue?vue&type=script&lang=js&"
export * from "./BusinessDetailsV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8836e554",
  null
  
)

export default component.exports